"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessTradeInState = /** @class */ (function () {
    function WirelessTradeInState() {
        this.isExpandedView = false;
        this.isTradeInDone = false;
        this.isTradeInSelected = false;
        this.isTradeInModalOpened = false;
        this.sharedOfferModalDisplayed = false;
        this.tradeInOfferModalDisplayed = false;
    }
    return WirelessTradeInState;
}());
exports.default = WirelessTradeInState;
//# sourceMappingURL=WirelessTradeInState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessTradeIn/WirelessTradeInState.js
// module id = 2294
// module chunks = 8